import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const staffType = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name of the staff type.'),

    description: z
      .string()
      .nullable()
      .optional()
      .describe('Description of this staff type.'),

    candidates: hasMany('Candidate', 'staffTypeId'),

    positions: hasMany('Position', 'staffTypeId'),
  })
  .describe(
    'A classification of staffing role, such as volunteer, contractor, or full-time.',
  )
  .as('StaffType');

export { staffType as staffTypeSchema };
